import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, finalize, map, of, Subscription, switchMap, tap } from 'rxjs';
import { WaitHandler } from 'src/app/accountancy/utilities/classes/wait-handler.class';
import { AccountingApiService } from 'src/app/accountancy/utilities/services/accounting-api/accounting-api.service';
import { GeneralLedgerInterface } from '../../../utilities/interfaces/global.interface';
import { Routes } from 'src/app/accountancy/utilities/classes/routes.class';
import { GeneralLedgerItemService } from '../../general-ledger/general-ledger-item/general-ledger-item-service/general-ledger-item.service';

@Component({
  selector: 'app-recent-activities',
  templateUrl: './recent-activities.component.html',
  styleUrls: ['./recent-activities.component.scss']
})
export class RecentActivitiesComponent implements OnDestroy {

  public readonly routes = Routes;

  public readonly waitHandler = new WaitHandler();
  public readonly list$ = new BehaviorSubject<GeneralLedgerInterface[]>([]);

  private readonly _subsGetRecentGL: Subscription = this._getSubsRecentGL();

  constructor(
    private _apiS: AccountingApiService,
    private _generalLS: GeneralLedgerItemService
  ) { }

  ngOnDestroy(): void {
    this._subsGetRecentGL.unsubscribe();
  }

  public onOpen(item: GeneralLedgerInterface) {
    this._generalLS.next(item);
  }

  private _getSubsRecentGL(): Subscription {
    return of(null).pipe(
      
      // ISSUE HERE
      // tap(() => this.waitHandler.newRequest()),
      // switchMap(() => this._apiS.generalLedger.gellAll(0, 5).pipe(
      //   finalize(() => this.waitHandler.finishRequest()),
      //   map(values => values.body?.data),
      //   tap(values => this.list$.next(values ?? [])),
      // ))

    ).subscribe();
  }

}
